export default {
    name: 'ErrorView',
    computed: {
        isUserLoggedIn() {
            const token = this.$store.getters.getUserToken;
            
            let redirectRoute = {name: 'Landing Page'};

            if (token) {
                const userDetails = this.$store.getters.getUserDetails;
                if(userDetails.userRole === 'BRDER') {
                    redirectRoute = {name: 'Sell Your Dog'};
                } else {
                    redirectRoute = {name: 'Dashboard'};
                }
            }
            
            return redirectRoute;
        }
    }
}